module.exports = __webpack_public_path__ + "static/media/SpringVille_PH1_1.44f4be47.webp";